import { ProjectCreated, ProjectUpdated } from '../project/project.actions';
import { createReducer, on } from '@ngrx/store';
import {
  LoadLatestConfigForProject,
  LoadDeployedConfigForProject,
  LoadConfigSchemaSuccess,
  LoadConfigSchemaFailed,
  SetCurrentConfig,
  CreateConfigWithOptionalDeploySucceeded,
  SetLoadConfigError,
  SetCreateConfigError,
  DeployConfig,
  SetDeployConfigError,
  SetAvatar,
  ResetAvatar,
  RemoveConfigError,
  DeployConfigSucceeded,
  DeployConfigSkipped,
  DeployMediaAssetCreatorConfigErrored,
  DeployPreviewConfigErrored,
  ConfigEffectActions,
  ConfigActions,
} from './config.actions';
import { ConfigApiError } from './config.errors';
import { Config } from './models/config.model';

export interface ConfigState {
  current: Config;
  selectedAvatar: string;
  requestInProgress: boolean;
  error: ConfigApiError;
  schema: any;
}

export const initialState: ConfigState = {
  current: null,
  selectedAvatar: null,
  requestInProgress: false,
  error: null,
  schema: null,
};

export const configReducer = createReducer(
  initialState,
  on(LoadLatestConfigForProject, (state) => ({
    ...state,
    current: null,
    requestInProgress: true,
    error: null,
  })),
  on(LoadDeployedConfigForProject, (state) => ({
    ...state,
    current: null,
    requestInProgress: true,
    error: null,
  })),
  on(LoadConfigSchemaSuccess, (state, { payload }) => ({ ...state, schema: payload })),
  on(LoadConfigSchemaFailed, (state, { error }) => ({ ...state, error })),
  on(SetCurrentConfig, (state, { config }) => ({
    ...state,
    current: config,
    requestInProgress: false,
  })),
  on(CreateConfigWithOptionalDeploySucceeded, (state, { config }) => ({
    ...state,
    current: config,
  })),
  on(SetLoadConfigError, (state, { error }) => ({
    ...state,
    error,
    requestInProgress: false,
  })),
  on(SetCreateConfigError, (state, { error }) => ({
    ...state,
    error,
    requestInProgress: false,
  })),
  on(DeployConfig, ConfigActions.undeployConfirmationClicked, (state) => ({
    ...state,
    requestInProgress: true,
    error: null,
  })),
  on(
    SetDeployConfigError,
    DeployMediaAssetCreatorConfigErrored,
    DeployPreviewConfigErrored,
    ConfigEffectActions.undeployErrored,
    (state, { error }) => ({
      ...state,
      requestInProgress: false,
      error,
    }),
  ),
  on(SetAvatar, (state, { avatarName }) => ({ ...state, selectedAvatar: avatarName })),
  on(ResetAvatar, (state) => ({ ...state, selectedAvatar: null })),
  on(RemoveConfigError, (state) => ({ ...state, error: null })),
  on(
    DeployConfigSucceeded,
    DeployConfigSkipped,
    ConfigEffectActions.undeploySucceeded,
    (state) => ({
      ...state,
      requestInProgress: false,
    }),
  ),
  on(ProjectCreated, ProjectUpdated, (state) => ({ ...state, requestInProgress: true })),
);
